import {
    fetchAuthSession,
  } from '@aws-amplify/auth';

export const getToken = async (): Promise<string> => {
    try {
        const session = await fetchAuthSession();
        const accessToken = session.tokens?.accessToken?.toString() || '';
        const idToken = session.tokens?.idToken?.toString() || '';
        // console.log("Access Token", accessToken)
        // console.log("Id Token", idToken)
        return idToken;
    } catch (error) {
      console.error('Error fetching token:', error);
      throw error;
    }
  };